import React, { useState, useEffect } from "react";
import { useRecoilValue } from "recoil";
import { configState } from "../../context/configState";
import { totalAssetBonded } from "../../context/totalAssetBonded";
import { totalAssetPooled } from "../../context/totalAssetPooled";
import { totalAssetState } from "../../context/totalAssetState";
import { useSnip20Token } from "../../hooks/useSnip20Token";
import { useToken } from "../../hooks/useToken";
import { useTotalAssetState } from "../../hooks/useTotalAssetState";
import { formatCompactNumber } from "../../utils/common";
import RewardClaim from "../common/layout/RewardClaim";
import { walletState } from "../../context/walletState";

const MyAssets = () => {
  const { getTotalAsset, getTotalBonded, getTotalPooled } =
    useTotalAssetState();
    const { client, address } = useRecoilValue(walletState);
  const totalAssetDollar = useRecoilValue(totalAssetState);
  const totalAssetBondedDollar = useRecoilValue(totalAssetBonded);
  const totalAssetPooledDollar = useRecoilValue(totalAssetPooled);
  useEffect(() => {
    getTotalAsset();
    getTotalBonded();
    getTotalPooled();
  }, [address]);

  const { getBalance } = useToken();
  const { unWrapToken, wrapToken } = useSnip20Token();
  const { assetsMap } = useRecoilValue(configState);
  const handlewrap = async () => {
    // const balanceSjuno = await getBalance("sSCRT");
    // const balanceJuno = await getBalance("SCRT");
    // const unWrap = () =>{
    //   const unwrapRes = unWrapToken("sSCRT", "0.001", assetsMap["sSCRT"].ibc?.scrt_denom);
    // }
    // unWrap();
    // const wrap = () =>{
    //   const wrapRes = wrapToken("sSCRT", "0.000001");
    // }
    // wrap();
  };

  return (
    <div className="myasset-wrapper">
      <div className="pool-header-container">My Assets</div>
      <div className="myasset-container poolinfo-container poolinfo-container-image image-container-properties">
        <div>
          <span>Total Assets</span>
          <p> ${formatCompactNumber(totalAssetDollar)}</p>
        </div>
        <div>
          <span>Bonded Assets</span>
          <p>${totalAssetBondedDollar.toLocaleString("en-US")}</p>
        </div>
        <div>
          <span>Available Assets</span>
          <p>
            $
            {formatCompactNumber(
              (totalAssetDollar - totalAssetBondedDollar).toFixed(4)
            )}
          </p>
        </div>
        <div>
          <span>Pooled Assets</span>
          <p>${totalAssetPooledDollar.toLocaleString("en-US")}</p>
        </div>
        <div>
          <span>Pending Rewards (SLIQ)</span>
          <div>
            <RewardClaim />
          </div>
        </div>
        {/* <div >
          <span>wrap</span>
          <div><button onClick={handlewrap}>wrap</button></div>
        </div> */}
      </div>
    </div>
  );
};

export default MyAssets;
